export function uploadRecording(blob, type, fpoptions, onSuccess, onError) {
    if (!blob) {
        onError && onError('No hay blob para subir');
        return;
    }

    // Definimos tipos válidos
    const validTypes = {
        audio: {
            mime: ['audio/ogg', 'audio/webm', 'audio/mpeg', 'audio/wav'],
            ext: ['ogg', 'webm', 'mp3', 'wav']
        },
        video: {
            mime: ['video/webm', 'video/mp4', 'video/ogg'],
            ext: ['webm', 'mp4', 'ogv']
        }
    };

    // Detecta el mimetype devuelto por el navegador o asigna uno válido
    let mimeType = blob.type || (type === 'audio' ? 'audio/ogg' : 'video/webm');
    if (!validTypes[type].mime.includes(mimeType)) {
        mimeType = validTypes[type].mime[0]; // fallback seguro
    }

    // Elige extensión en base al mimetype
    const extMap = {
        'audio/ogg': 'ogg',
        'audio/webm': 'webm',
        'audio/mpeg': 'mp3',
        'audio/wav': 'wav',
        'video/webm': 'webm',
        'video/mp4': 'mp4',
        'video/ogg': 'ogv'
    };
    const extension = extMap[mimeType] || (type === 'audio' ? 'ogg' : 'webm');

    // Nombre único
    const fileName = `${type}-recording-${Date.now()}.${extension}`;
    const file = new File([blob], fileName, { type: mimeType });

    // Preparamos FormData
    const formData = new FormData();
    formData.append('upload', file, fileName);
    formData.append('title', fileName);
    formData.append('action', 'upload');

    // Extrae valores de fpoptions (con fallback)
    formData.append('repo_id', fpoptions.repositoryid);
    formData.append('ctx_id', fpoptions.contextid);
    formData.append('itemid', fpoptions.itemid);
    formData.append('author', fpoptions.author || 'ckeditor');
    formData.append('env', fpoptions.env || 'editor');
    formData.append('sesskey', fpoptions.sesskey || M.cfg.sesskey);

    // Hacemos el fetch
    fetch(M.cfg.wwwroot + '/lib/editor/ckeditorballoonblock/ajax.php', {
        method: 'POST',
        body: formData
    })
    .then(res => res.text()) // Moodle a veces mete HTML
    .then(text => {
        const jsonMatch = text.match(/\{[\s\S]*\}$/);
        if (!jsonMatch) throw new Error('Respuesta inesperada del servidor');

        const data = JSON.parse(jsonMatch[0]);

        if (data.error && data.error.message) {
            onError && onError(data.error.message);
            return;
        }

        const url = data.url || data.link || (data.file && data.file.url);
        if (!url) {
            onError && onError('No se recibió URL en la respuesta');
            return;
        }

        onSuccess && onSuccess(url);
    })
    .catch(err => {
        console.error(' Error en fetch:', err);
        onError && onError(err.message);
    });
}
